import React from 'react';
import { isEmpty } from 'lodash/lang';
import LightTooltip from 'mui/Tooltip/LightTooltip';
import { formatDate } from 'services/date';

import { usePatientInfo } from '../../../../../PatientInfoContext';
import { getEventStartDate } from '../../../utils';
import { useEncounterCard } from '../EncounterCard';

import './ProjectedEvents.scss';

export default function ProjectedEvents() {
  const { currentStudy } = usePatientInfo();
  const { encounter } = useEncounterCard();
  const { events } = encounter;
  return (
    events &&
    !isEmpty(events) && (
      <div className="projected-events-rows">
        <div className="projected-events-rows-title">Canceled Appointments</div>
        {events.map(function(event) {
          const { id, start, cancellationComments, windowStartDate, windowEndDate } = event;
          return (
            <div key={id} className="projected-events-row projected-events-row-cancelled">
              <LightTooltip
                arrow
                title={
                  <div className="date-window-tooltip">
                    <span className="date-window-tooltip-title">Expected Encounter Window:</span>
                    <div className="date-window-tooltip-range">
                      {formatDate(windowStartDate)}
                      {' - '}
                      {formatDate(windowEndDate)}
                    </div>
                  </div>
                }
              >
                <div className="projected-events-row-start-date">{getEventStartDate(start, currentStudy)}</div>
              </LightTooltip>
              <div className="projected-events-row-comments">
                {!isEmpty(cancellationComments) && cancellationComments}
              </div>
            </div>
          );
        })}
      </div>
    )
  );
}
